export function extractAranIdFromResponse(data) {
  const aran = (data && data.result) || data;
  if (!aran || aran._id == null) {
    return null;
  }
  return String(aran._id);
}

export function getAranIdFromEvent(event) {
  if (!event || event.aran == null || event.aran === "") {
    return "";
  }
  if (typeof event.aran === "string") {
    return event.aran;
  }
  if (typeof event.aran === "object" && event.aran._id != null) {
    return String(event.aran._id);
  }
  return String(event.aran);
}



// WEBPACK FOOTER //
// ./src/utils/aran.js